"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatePickerInput = void 0;
var tslib_1 = require("tslib");
var format_1 = (0, tslib_1.__importDefault)(require("date-fns/format"));
var moment_1 = (0, tslib_1.__importDefault)(require("moment"));
var react_1 = (0, tslib_1.__importStar)(require("react"));
var __1 = require("../..");
var key_event_1 = require("../../../../hooks/key-event");
var tether_1 = require("../../../../hooks/tether");
var box_1 = require("../../../box");
var fade_in_1 = require("../../../fade-in");
var input_1 = require("../../../input");
var padding_1 = require("../../../padding");
var popover_1 = require("../../../popover");
var FORMATTERS = ['MM-DD-YYYY', 'MMM-DD-YYYY', 'MMM-DD', 'DD-MM', 'DD-MM-YYYY', 'YYYY-MM-DD'];
function DatePickerInput(props) {
    var _a = props.autoComplete, autoComplete = _a === void 0 ? false : _a, disableWeekends = props.disableWeekends, disabled = props.disabled, _b = props.format, format = _b === void 0 ? 'YYYY-MM-DD' : _b, initValue = props.initValue, isRequired = props.isRequired, maxDate = props.maxDate, maxYear = props.maxYear, minDate = props.minDate, minYear = props.minYear, name = props.name, onChange = props.onChange, fieldId = props.fieldId, testId = props.testId, clearOnDisabled = props.clearOnDisabled, size = props.size;
    var _c = (0, react_1.useState)(false), visible = _c[0], setVisible = _c[1];
    var initCleanValue = null;
    function formatInitialValue() {
        if (initValue != null && initValue !== '') {
            if (typeof initValue === 'object') {
                initCleanValue = (0, moment_1.default)({ year: initValue.year, month: initValue.month - 1, day: initValue.day }).format(format);
            }
            else
                initCleanValue = (0, format_1.default)(initValue, format);
        }
    }
    formatInitialValue();
    var _d = (0, react_1.useState)(initCleanValue), value = _d[0], setValue = _d[1];
    (0, react_1.useEffect)(function () {
        formatInitialValue();
        setValue(initCleanValue);
    }, [initValue]);
    function isOutOfRange(currentValue) {
        var parsed = (0, moment_1.default)(currentValue || '', FORMATTERS);
        if (!parsed.isValid())
            return false;
        if (disableWeekends && parsed.toDate().getDay() % 6 === 0)
            return false;
        if (minDate && maxDate)
            return parsed.isBefore((0, moment_1.default)(minDate)) || parsed.isSameOrAfter((0, moment_1.default)(maxDate));
        if (minDate)
            return parsed.isBefore((0, moment_1.default)(minDate));
        if (maxDate)
            return parsed.isSameOrAfter((0, moment_1.default)(maxDate));
        return false;
    }
    var _e = (0, tether_1.useTether)({
        attachment: 'top left',
        targetAttachment: 'bottom left',
        constraints: [
            {
                to: 'window',
                pin: true,
                attachment: 'bottom',
            },
        ],
    }), targetRef = _e.targetRef, elementRef = _e.elementRef;
    (0, key_event_1.useKeyEvent)('Tab', function () {
        setVisible(false);
        var parsed = (0, moment_1.default)(value || '', FORMATTERS);
        if (parsed.isValid()) {
            setValue(parsed.format(format));
        }
    }, []);
    react_1.default.useEffect(function () {
        var parsed = (0, moment_1.default)(value || '', FORMATTERS);
        if (onChange) {
            if (parsed.isValid())
                onChange(value);
            else
                onChange(value || null);
        }
    }, [value]);
    function completeDate(currentValue) {
        var parsed = (0, moment_1.default)(currentValue || '', FORMATTERS);
        if (parsed.isValid())
            setValue((0, format_1.default)(parsed.toISOString(), format));
    }
    var isInvalid;
    if (value === '' || value === null)
        isInvalid = false;
    else
        isInvalid = isOutOfRange(value) || !(0, moment_1.default)(value, FORMATTERS).isValid();
    var val = clearOnDisabled && value !== null ? '' : value;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(input_1.Input, { disabled: disabled, innerRef: targetRef, name: name, fieldId: fieldId, testId: testId, onChange: setValue, onFocus: function () { return setVisible(true); }, onBlur: function (currentValue) { return completeDate(currentValue); }, placeholder: format, type: "date", value: val, isRequired: isRequired, autoComplete: autoComplete ? 'on' : 'off', isInvalid: isInvalid, size: size }),
        react_1.default.createElement(popover_1.Popover, { isOpen: visible, onToggle: setVisible, innerRef: elementRef },
            react_1.default.createElement(fade_in_1.FadeIn, { yOffset: "-5px", duration: "200ms" },
                react_1.default.createElement(box_1.Box, { style: { background: 'white' }, border: 1, borderRadius: 3, boxShadow: "overlay" },
                    react_1.default.createElement(padding_1.Padding, { size: 8 },
                        react_1.default.createElement(__1.DatePicker, { disableWeekends: disableWeekends, value: value, minDate: minDate, maxDate: maxDate, minYear: minYear || undefined, maxYear: maxYear || undefined, onChange: function (newValue) {
                                setVisible(false);
                                if (newValue)
                                    setValue((0, format_1.default)(newValue, format));
                                else
                                    setValue(null);
                            } })))))));
}
exports.DatePickerInput = DatePickerInput;
//# sourceMappingURL=index.js.map